export default __webpack_public_path__ + "static/media/handMobile.19c8e357.jpg";